import React, { useRef } from "react";
import { CSSTransition } from "react-transition-group";

/**
 * Specification of the fade duration given in milliseconds.
 */
const DURATION = 275;

/**
 * Css fade transition that'll fade between throbber and reference preview once
 * data has been fetched.
 */
// tslint:disable-next-line variable-name
export const ReferencePreviewFade: React.FC<{ children: React.ReactNode }> = (
  props
) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <CSSTransition
      {...props}
      classNames="progress__preview__ReferencePreviewFade"
      timeout={DURATION}
      mountOnEnter
      unmountOnExit
      nodeRef={ref}
    >
      <div ref={ref} className="progress__preview__ReferencePreviewFade">
        {props.children}

        <style jsx global>{`
          .progress__preview__ReferencePreviewFade {
            /** Stretch to fit container in order to allow children to do the same */
            width: 100%;
            height: 100%;
          }

          .progress__preview__ReferencePreviewFade-enter {
            /** Force the element to overlap */
            position: relative;
            z-index: 1;

            /** Prepare fade-in */
            opacity: 0.001;
          }

          .progress__preview__ReferencePreviewFade-enter-active {
            opacity: 1;
            transition: opacity ${DURATION}ms linear;
          }

          .progress__preview__ReferencePreviewFade-exit {
            /** Underlap the block */
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 0;

            /** Prepare fade-out */
            opacity: 1;
          }

          .progress__preview__ReferencePreviewFade-exit-active {
            opacity: 0.001;
            transition: opacity ${DURATION}ms linear;
          }
        `}</style>
      </div>
    </CSSTransition>
  );
};
